<template>
  <div>
    <h4> {{$t('leads.details.hearing_test_web')}}</h4>
    <template>
      <div v-if="ht">
        <div>
          <span class="is-bold">{{$t('leads.details.ht_web.test_type')}}:</span> {{ $t(`leads.details.ht_web.${ht.test_type}`) }}
        </div>
        <div>
          <span class="is-bold">{{$t('leads.details.ht_web.version')}}:</span> {{ ht.test_version }}
        </div>
        <div v-if="ht.headphones_type && ht.headphones_type==='mono'">
          <span class="is-bold">{{$t('leads.details.mono_result')}}:</span>
          <span> {{ resultLabel('left') }}<template v-if="showSnr('left')"> ({{$t('leads.details.ht_web.difference_sound_noise')}}: {{ snr('left') }} dB)</template></span>
        </div>
        <span v-else>
          <div>
            <span class="is-bold">{{$t('leads.details.left')}}:</span>
            <span> {{ resultLabel('left') }}<template v-if="showSnr('left')"> ({{$t('leads.details.ht_web.difference_sound_noise')}}: {{ snr('left') }} dB)</template></span>
          </div>
          <div>
            <span class="is-bold">{{$t('leads.details.right')}}:</span>
            <span> {{ resultLabel('right') }}<template v-if="showSnr('right')"> ({{$t('leads.details.ht_web.difference_sound_noise')}}: {{ snr('right') }} dB)</template></span>
          </div>
        </span>
      </div>
      <div v-else>
        {{$t('leads.details.no_result')}}
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: ['ht'],
  data () {
    return {
    }
  },
  methods: {
    /** pass | refer | non_conclusive — prefers persisted calculated_result, falls back to hl_* */
    earResult (side) {
      const calc = side === 'left' ? this.ht.calculated_result_left : this.ht.calculated_result_right
      if (calc) return calc
      const hl = side === 'left' ? this.ht.hl_left : this.ht.hl_right
      return hl ? 'refer' : 'pass'
    },
    resultLabel (side) {
      const result = this.earResult(side)
      if (result === 'non_conclusive') {
        return this.$t('leads.details.ht_web.non_conclusive')
      }
      if (result === 'refer') {
        return this.$t('leads.details.ht_web.with_hearing_loss')
      }
      return this.$t('leads.details.ht_web.without_hearing_loss')
    },
    snr (side) {
      const sound = side === 'left' ? this.ht.sound_left : this.ht.sound_right
      const noise = side === 'left' ? this.ht.noise_left : this.ht.noise_right
      return sound - noise
    },
    showSnr (side) {
      if (this.earResult(side) === 'non_conclusive') return false
      const sound = side === 'left' ? this.ht.sound_left : this.ht.sound_right
      const noise = side === 'left' ? this.ht.noise_left : this.ht.noise_right
      return sound != null && noise != null && !(Number(sound) === 0 && String(this.ht.test_version || '').indexOf('MO') === 0)
    }
  },
  computed: {
    activeHearingTest: function () {
      if (this.ht) {
        return this.ht.id
      }
    }
  },
  watch: {
    activeHearingTest: {
      immediate: true,
      handler (value) {
        if (this.ht) {
          // this.updateResults(this.ht.result)
        }
      }
    }
  }
}
</script>
